import ministryService from "../../../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      instructions: {},
      hints: [],
      loading: false,
      working: false,
    };
  },
  getters: {
    instructions(state) {
      return state.instructions;
    },
    hints(state) {
      return state.hints;
    },
    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setInstructions(state, payload) {
      state.instructions = payload;
    },
    setHints(state, payload) {
      state.hints = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async fetchInstructions({ commit }, id) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchInstructions(id);
        commit("setInstructions", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchHints({ commit, getters }) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchHints(
          getters["instructions"].slug
        );
        commit("setHints", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async editInstructions({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.updateInstruction(payload);
        await dispatch("fetchInstructions", payload.id);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async editHints({ commit, getters, dispatch }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.updateHints({
          contents: payload,
          section_name: getters["instructions"].slug,
        });
        await dispatch("fetchHints");
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    // async addInstruction({ commit, dispatch }, payload) {
    //   commit("setWorking", true);
    //   try {
    //     await ministryService.addInstruction(payload);
    //     await dispatch("fetchInstructions");
    //   } catch (err) {
    //
    //   } finally {
    //     commit("setWorking", false);
    //   }
    // },
    // async deleteInstruction({ commit, dispatch }, id) {
    //   commit("setLoading", true);
    //   try {
    //     await ministryService.deleteInstruction(id);
    //     await dispatch("fetchInstructions");
    //   } catch (err) {
    //
    //   } finally {
    //     commit("setLoading", false);
    //   }
    // },
  },
};
